import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useRouteMatch} from 'react-router-dom';
import {i18n} from 'src/i18n';
import {getHistory} from 'src/modules/store';
import actions from 'src/modules/ubicacion/form/ubicacionFormActions';
import selectors from 'src/modules/ubicacion/form/ubicacionFormSelectors';
import ContentWrapper from 'src/view/layout/styles/ContentWrapper';
import Breadcrumb from 'src/view/shared/Breadcrumb';
import Spinner from 'src/view/shared/Spinner';
import PageTitle from 'src/view/shared/styles/PageTitle';
import UbicacionForm from 'src/view/ubicacion/form/UbicacionForm';
import UbicacionFormMulti from './UbicacionFormMulti';

function UbicacionFormPage(props) {
  const [dispatched, setDispatched] = useState(false);
  const dispatch = useDispatch();
  const match = useRouteMatch();

  const initLoading = useSelector(selectors.selectInitLoading);
  const saveLoading = useSelector(selectors.selectSaveLoading);
  const record = useSelector(selectors.selectRecord);

  const multi = props.multi; // Set to true to use UbicacionFormMulti

  const isEditing = multi ? false : Boolean(props.record?.id || match.params.id);

  const title = isEditing ? i18n('entities.ubicacion.edit.title') : i18n('entities.ubicacion.new.title');

  useEffect(() => {
    dispatch(actions.doInit(props.record?.id || match.params.id));
    setDispatched(true);
  }, [dispatch, match.params.id]);

  const doSubmit = (id, data) => {
    if (isEditing) {
      dispatch(actions.doUpdate(id, data));
    } else {
      dispatch(actions.doCreate(data));
    }
  };

  return (
    <>
      {!props.drawer ||
        (!props.disabled && (
          <Breadcrumb items={[[i18n('dashboard.menu'), '/'], [i18n('entities.ubicacion.menu'), '/ubicacion'], [title]]} />
        ))}

      <ContentWrapper>
        {!props.disabled && <PageTitle>{title}</PageTitle>}

        {initLoading && <Spinner />}

        {dispatched && !initLoading && !multi && (
          <UbicacionForm
            disabled={props.disabled}
            drawer={props.drawer}
            saveLoading={saveLoading}
            initLoading={initLoading}
            record={record}
            isEditing={isEditing}
            onSubmit={doSubmit}
            onCancel={() => getHistory().push('/ubicacion')}
          />
        )}
        {dispatched && !initLoading && multi && (
          <UbicacionFormMulti
            disabled={props.disabled}
            drawer={props.drawer}
            saveLoading={saveLoading}
            initLoading={initLoading}
            record={record}
            isEditing={isEditing}
            onSubmit={doSubmit}
          />
        )}
      </ContentWrapper>
    </>
  );
}

export default UbicacionFormPage;
